:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._mobileWizardFirstStep_b59kq_7 ._stepImage_b59kq_7 {
  display: block;
  margin: 9px auto 0;
  min-height: 231px; }

._mobileWizardFirstStep_b59kq_7 ._stepHeader_b59kq_12 {
  display: block;
  margin-top: 5px; }

._mobileWizardFirstStep_b59kq_7 ._stepSubHeader_b59kq_16 {
  display: block;
  margin-top: 10px;
  margin-bottom: 9px; }
